<template>
  <div>
    <div class="notification is-bordered is-margin-bottom-large is-acte is-paddingless"
          v-if="externalSale">
      <div class="columns is-variable is-1 is-padding-right-small is-padding-left-small " v-if="checkIsEmpty(externalSale)">
        <div class="column is-2 columns is-column is-space-between">
          <div class="is-size-6 is-margin-bottom-xsmall">Vendeur</div>
          <div class="is-size-5" v-if="externalSale.seller.first_name || externalSale.seller.last_name">
            {{externalSale.seller.last_name}} {{externalSale.seller.first_name}}</div>
          <div v-else>--</div>
        </div>
        <div class="column is-2 columns is-column is-space-between">
          <div class="is-size-6 is-margin-bottom-xsmall">Acheteur</div>
          <div class="is-size-5" v-if="externalSale.buyer.first_name || externalSale.buyer.last_name">
            {{externalSale.buyer.last_name}} {{externalSale.buyer.first_name}}</div>
          <div v-else>--</div>
        </div>
        <div class="column is-1"></div>
        <div class="column is-3 columns is-column is-space-between">
          <div class="is-size-6 is-margin-bottom-xsmall">Date de vente</div>
          <div class="is-size-5" v-if="externalSale.sale_date">{{externalSale.sale_date | prettyFullDatetime}}</div>
          <div v-else>--</div>
        </div>
        <div class="column is-3 columns is-column is-space-between">
          <div class="is-size-6 is-margin-bottom-xsmall">Prix de vente</div>
          <div class="is-size-5" v-if="externalSale.sale_price">{{externalSale.sale_price | prettyPrice}} {{$currency}}</div>
          <div v-else>--</div>
        </div>
      </div>
      <div class="columns is-variable is-1 is-padding-right-small is-padding-left-small " v-else>
        <div class="column is-12 columns is-column is-space-between">
          <div class="is-size-5">Vente externe renseignée, aucune information disponible.</div>
        </div>
      </div>
    </div>

    <div class="notification is-bordered is-margin-bottom-large is-paddingless" v-if="adv"
          :class="adv.status === 'sold' ? 'is-acte' : 'is-reserve'">
      <div class="columns is-variable is-1 is-padding-right-small is-padding-left-small " v-if="checkIsEmpty(adv)">
        <div class="column is-2 columns is-column is-space-between" v-if="adv.company">
          <div class="is-size-6 is-margin-bottom-xsmall">Société</div>
          <router-link :to="{name: 'CompanyVue', params: {id: adv.company}}" class="is-size-5" v-if="adv.company_name">{{adv.company_name}}</router-link>
          <div v-else>--</div>
        </div>
        <div class="column is-2 columns is-column is-space-between" v-else>
          <div class="is-size-6 is-margin-bottom-xsmall">Vendeur</div>
          <router-link :to="{name: 'UserVue', params: {id: adv.seller}}" class="is-size-5" v-if="adv.seller_name">{{adv.seller_name}}</router-link>
          <div v-else>--</div>
        </div>
        <div class="column is-2 columns is-column is-space-between">
          <div class="is-size-6 is-margin-bottom-xsmall">Acheteur</div>
          <router-link :to="{name: 'ContactVue', params: {id: adv.buyer}}" class="is-size-5" v-if="adv.buyer_name">{{adv.buyer_name}}</router-link>
          <div v-else>--</div>
        </div>
        <div class="column is-1"></div>
        <div class="column is-3 columns is-column is-space-between" v-if="adv.status === 'sold'">
          <div class="is-size-6 is-margin-bottom-xsmall">Date de vente</div>
          <div class="is-size-5" v-if="adv.sale_date">{{adv.sale_date | prettyFullDatetime}}</div>
          <div v-else>--</div>
        </div>
        <div class="column is-3 columns is-column is-space-between" v-if="adv.status === 'reserved' && !adv.signature_date">
          <div class="is-size-6 is-margin-bottom-xsmall">Date de passage en réservation</div>
          <div class="is-size-5" v-if="adv.reservation_date">{{adv.reservation_date | prettyFullDatetime}}</div>
          <div v-else>--</div>
        </div>
        <div class="column is-3 columns is-column is-space-between" v-if="adv.status === 'reserved' && adv.signature_date">
          <div class="is-size-6 is-margin-bottom-xsmall">Date de réservation</div>
          <div class="is-size-5" v-if="adv.signature_date">{{adv.signature_date | prettyFullDatetime}}</div>
          <div v-else>--</div>
        </div>
        <div class="column is-3 columns is-column is-space-between">
          <div class="is-size-6 is-margin-bottom-xsmall">Prix de vente</div>
          <div class="is-size-5" v-if="adv.sale_price_with_discount">{{adv.sale_price_with_discount | prettyPrice}} {{$currency}}</div>
          <div v-else>--</div>
        </div>
        <div class="column is-self-centered has-text-right">
          <display-button-list :forceDropDown="true" :buttons="advButtonList" :data="adv"
                                :canDropDown="!loadingOptionAction"
                                :icon-class="loadingOptionAction ? 'fa-spinner fa-spin' : 'fa-ellipsis-v'"
                                :classes="'is-outlined is-circle is-white'"></display-button-list>
        </div>
      </div>
      <div class="columns is-variable is-1 is-padding-right-small is-padding-left-small " v-else>
        <div class="column is-12 columns is-column is-space-between">
          <div class="is-size-5">Vente renseignée, aucune information disponible.</div>
        </div>
      </div>
    </div>

    <div class="notification is-bordered is-margin-bottom-large is-optionne is-paddingless"
          v-if="displayExternalOption">
      <div class="columns is-variable is-1 is-padding-right-small is-padding-left-small ">
        <div class="column is-12 columns is-column is-space-between">
          <div class="is-size-5">Option issue du flux, aucune information disponible.</div>
        </div>
      </div>
    </div>

    <div class="notification is-bordered is-margin-bottom-large is-optionne is-paddingless"
          v-if="firstOption">
      <div class="columns is-variable is-1 is-padding-right-small is-padding-left-small " v-if="checkIsEmpty(firstOption)">
        <div class="column is-2 columns is-column is-space-between" v-if="firstOption.company">
          <div class="is-size-6 is-margin-bottom-xsmall">Société</div>
          <router-link :to="{name: 'CompanyVue', params: {id: firstOption.company}}" class="is-size-5">{{firstOption.company_name}}</router-link>
        </div>
        <div class="column is-2 columns is-column is-space-between" v-if="firstOption.seller_name && !firstOption.company">
          <div class="is-size-6 is-margin-bottom-xsmall">Vendeur</div>
          <router-link :to="{name: 'UserVue', params: {id: firstOption.seller}}" class="is-size-5">{{firstOption.seller_name}}</router-link>
        </div>
        <div class="column is-2 columns is-column is-space-between" v-if="firstOption.buyer_name">
          <div class="is-size-6 is-margin-bottom-xsmall">Contact</div>
          <router-link :to="{name: 'ContactVue', params: {id: firstOption.buyer}}" class="is-size-5">{{firstOption.buyer_name}}</router-link>
        </div>
        <!-- <div class="column is-1"></div> -->
        <div class="column is-3 columns is-column is-space-between" v-if="firstOption.status !== 'approved'">
          <div class="is-size-6 is-margin-bottom-xsmall">Date de l'option</div>
          <div class="is-size-5">{{firstOption.start_date | prettyFullDatetime}}
          </div>
        </div>
        <div class="column is-3" v-if="firstOption.status === 'approved'">
          <div class="is-size-6 is-margin-bottom-xsmall">Option Acceptée le </div>
          <div class="is-size-5">{{firstOption.updated_on | prettyFullDatetime}}</div>
          <div v-if="(isAdmin || isSectorManager) && firstOption.author_name">par
            <router-link :to="{name: 'UserVue', params: {id: firstOption.update_author}}">
              {{firstOption.update_author_name}}
            </router-link>
          </div>
        </div>
        <div class="column is-3 columns is-column is-space-between" v-if="firstOption.status === 'approved'">
          <div class="is-size-6 is-margin-bottom-xsmall">Date d'expiration</div>
          <div class="is-size-5">{{firstOption.end_date | prettyFullDatetime}}</div>
        </div>
        <div class="column is-self-centered has-text-right" v-if="firstOption.seller_name">
          <display-button-list :forceDropDown="true" :buttons="optionButtonListFirstOption" :data="firstOption"
                                :canDropDown="!loadingOptionAction"
                                :icon-class="loadingOptionAction ? 'fa-spinner fa-spin' : 'fa-ellipsis-v'"
                                :classes="'is-outlined is-circle is-grey-dark'"></display-button-list>
        </div>
      </div>
      <div class="columns is-variable is-1 is-padding-right-small is-padding-left-small " v-else>
        <div class="column is-12 columns is-column is-space-between">
          <div class="is-size-5">Option renseignée, aucune information disponible.</div>
        </div>
      </div>
    </div>

    <div v-if="waitingList && waitingList.length > 0"
      class="notification is-bordered is-margin-bottom-large is-warning is-paddingless has-bg-warning-darken-1">
      <div
        class="is-padding-right-small is-padding-left-small is-padding-top-xsmall is-padding-bottom-xsmall columns">
        <div class="column is-8 is-paddingless">
          <span class="is-size-6">{{waitingList.length}} option<span v-if="waitingList.length > 1">s</span> validée<span v-if="waitingList.length > 1">s</span> en liste d'attente</span>
        </div>
        <div class="column is-4 is-paddingless has-text-right">
          <a @click="displayWaitingList = !displayWaitingList" class="is-size-6 is-padding-right-xsmall"
              style="text-decoration: none;">
            {{displayWaitingList ? 'Fermer' : 'Détails de l\'option'}}
            <span class="icon is-small">
              <i class="fal" :class="displayWaitingList ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'"></i>
            </span>
          </a>
        </div>
      </div>
      <div class="columns is-gapless has-bg-warning is-padding-right-small is-padding-left-small" v-for="w in waitingList" :key="w.pk"
            v-if="displayWaitingList">
        <div class="column is-2 columns is-column is-space-between is-padding-xsmall" v-if="w.company">
          <div class="is-size-6 is-margin-bottom-xsmall">Société</div>
          <router-link :to="{name: 'CompanyVue', params: {id: w.company}}" class="is-size-5">{{w.company_name}}</router-link>
        </div>
        <div class="column is-2 columns is-column is-space-between is-padding-xsmall" v-if="w.seller_name && !w.company">
          <div class="is-size-6 is-margin-bottom-xsmall">Vendeur</div>
          <router-link :to="{name: 'UserVue', params: {id: w.seller}}" class="is-size-5">{{w.seller_name}}</router-link>
        </div>
        <div class="column is-2 columns is-column is-space-between is-padding-xsmall" v-if="w.buyer_name">
          <div class="is-size-6 is-margin-bottom-xsmall">Contact</div>
          <router-link :to="{name: 'ContactVue', params: {id: w.buyer}}" class="is-size-5">{{w.buyer_name}}</router-link>
        </div>
        <div class="column is-1"></div>
        <div class="column is-3 columns is-column is-space-between is-padding-xsmall">
          <div class="is-size-6 is-margin-bottom-xsmall">Date de l'option</div>
          <div class="is-size-5">{{w.start_date | prettyFullDatetime}}</div>
        </div>
        <div class="column is-self-centered has-text-right" v-if="isAdmin || isSectorManager">
          <display-button-list :forceDropDown="true" :buttons="optionButtonListWaitingOption" :data="w"
          :canDropDown="!loadingOptionAction"
                                :icon-class="loadingOptionAction ? 'fa-spinner fa-spin' : 'fa-ellipsis-v'"
                                :classes="'is-outlined is-circle is-grey-dark'"></display-button-list>
        </div>
      </div>
    </div>

    <notification-item v-if="userPendingOption"
                       :source="userPendingOption"
                       :button-list="optionButtonList"
                       :noneLabel="'Option renseignée, aucune information disponible.'"
    ></notification-item>

    <div class="notification is-bordered is-margin-bottom-large is-info is-paddingless"
          v-if="userPendingOption">
      <div class="columns is-variable is-1 is-padding-right-small is-padding-left-small" v-if="checkIsEmpty(userPendingOption)">
        <div class="column is-3 columns is-column is-space-between">
          <div class="is-size-6 is-margin-bottom-xsmall">Option</div>
          <div class="is-size-5">
            <router-link :to="{name: 'OptionList'}" class="has-text-white">En attente de validation</router-link>
          </div>
        </div>
        <div class="column is-3 columns is-column is-space-between">
          <div class="is-size-6 is-margin-bottom-xsmall">Date de l'option</div>
          <div class="is-size-5">{{userPendingOption.start_date | prettyFullDatetime}}</div>
        </div>
        <div class="column is-one-fifth columns is-column is-space-between" v-if="userPendingOption.buyer_name">
          <div class="is-size-6 is-margin-bottom-xsmall">Contact</div>
          <router-link :to="{name: 'ContactVue', params: {id: userPendingOption.buyer}}" class="is-size-5">{{userPendingOption.buyer_name}}</router-link>
        </div>
        <div class="column is-self-centered has-text-right">
          <display-button-list :forceDropDown="true" :buttons="optionButtonList" :data="userPendingOption"
          :canDropDown="!loadingOptionAction"
                                :icon-class="loadingOptionAction ? 'fa-spinner fa-spin' : 'fa-ellipsis-v'"
                               :classes="'is-outlined is-circle is-white'"></display-button-list>
        </div>
      </div>
      <div class="columns is-variable is-1 is-padding-right-small is-padding-left-small " v-else>
        <div class="column is-12 columns is-column is-space-between">
          <div class="is-size-5">Option renseignée, aucune information disponible.</div>
        </div>
      </div>
    </div>

    <div
      class="notification is-bordered is-margin-bottom-large is-info is-paddingless has-bg-info-darken-1"
      v-if="(isAdmin || isSectorManager) && pendingOptions.length > 0">
      <div
        class="is-padding-right-small is-padding-left-small is-padding-top-xsmall is-padding-bottom-xsmall columns">
        <div class="column is-8 is-paddingless">
          <span class="is-size-6">{{pendingOptions.length}} option<span v-if="pendingOptions.length > 1">s</span> en attente de validation</span>
        </div>
        <div class="column is-4 is-paddingless has-text-right">
          <a @click="displayPendingList = !displayPendingList" class="is-size-6 is-padding-right-xsmall"
              style="text-decoration: none;">
            {{displayPendingList ? 'Fermer' : 'Détails de l\'option'}}
            <span class="icon is-small">
              <i class="fal" :class="displayPendingList ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'"></i>
            </span>
          </a>
        </div>
      </div>
      <div class="columns is-gapless is-padding-right-small is-padding-left-small has-bg-info"
           v-for="o in pendingOptions" :key="o.pk" v-if="displayPendingList">
        <div class="column is-2 columns is-column is-space-between is-padding-xsmall" v-if="o.company_name">
          <div class="is-size-6 is-margin-bottom-xsmall">Société</div>
          <router-link :to="{name: 'CompanyVue', params: {id: o.company}}" class="is-size-5">{{o.company_name}}</router-link>
        </div>
        <div class="column is-2 columns is-column is-space-between is-padding-xsmall" v-if="o.seller_name && !o.company">
          <div class="is-size-6 is-margin-bottom-xsmall">Vendeur</div>
          <router-link :to="{name: 'UserVue', params: {id: o.seller}}" class="is-size-5">{{o.seller_name}}</router-link>
        </div>
        <div class="column is-2 columns is-column is-space-between is-padding-xsmall" v-if="o.buyer_name">
          <div class="is-size-6 is-margin-bottom-xsmall">Contact</div>
          <router-link :to="{name: 'ContactVue', params: {id: o.buyer}}" class="is-size-5">{{o.buyer_name}}</router-link>
        </div>
        <div class="column is-1"></div>
        <div class="column is-3 columns is-column is-space-between is-padding-xsmall">
          <div class="is-size-6 is-margin-bottom-xsmall">Date de l'option</div>
          <div class="is-size-5">{{o.start_date | prettyFullDatetime}}</div>
        </div>
        <div class="column is-self-centered has-text-right" v-if="isAdmin || isSectorManager">
          <display-button-list :forceDropDown="true" :buttons="optionButtonList" :data="o"
                               :canDropDown="!loadingOptionAction"
                               :icon-class="loadingOptionAction ? 'fa-spinner fa-spin' : 'fa-ellipsis-v'"
                               :classes="'is-outlined is-circle is-white'"></display-button-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { isEmpty } from 'lodash'
  import { DefaultValues, OptionStatus } from '../../mixins'
  import { downloadURI } from '@/utils'

  export default {
    name: 'LotStatusNotifications',
    mixins: [DefaultValues, OptionStatus],
    data () {
      return {
        displayPendingList: false,
        displayWaitingList: false,
        loadingOptionAction: false,
        optionButtonList: [
          {
            action: (id, option) => {
              this.$store.commit('setQuickview', {mode: 'OPTION_UPDATE_DATE', params: {source: option}})
            },
            icon: 'fa-clock',
            text: 'Modifier date de fin',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canUpgrade(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.$router.push({name: 'ResaCreate', params: {id}})
            },
            icon: 'fa-handshake',
            text: 'Passer en réservation',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canUpgrade(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.loadingOptionAction = true
              this.$api.optionService.patch(id, {status: 'approved'}).then(r => {
                this.updateOption(id, r.data, {
                  text: 'L\'option a été acceptée.', type: 'is-success'
                })
              })
            },
            icon: 'fa-check',
            text: 'Accepter',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canApprove(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.loadingOptionAction = true
              this.confirmDelete().then(r => {
                this.loadingOptionAction = false
                if (r.value) {
                  this.$api.optionService.patch(id, {status: 'refused'}).then(r => {
                    this.updateOption(id, r.data, {text: 'L\'option a été refusée.', type: 'is-success'})
                  })
                }
              })
            },
            icon: 'fa-times-octagon',
            needProfile: ['admin', 'sector_manager'],
            text: 'Refuser',
            display: (o) => {
              return this.canRefuse(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.loadingOptionAction = true
              this.deleteOption(id)
              // this.updateOption(id, {}, {text: 'L\'option a été acceptée.', type: 'is-success'})
            },
            icon: 'fal fa-undo',
            text: 'Annuler demande d\'option',
            display: (o) => {
              return this.canCancel(o.status)
            }
          }
        ],
        optionButtonListFirstOption: [
          {
            action: (id, option) => {
              this.$store.commit('setQuickview', {mode: 'OPTION_UPDATE_DATE', params: {source: option}})
            },
            icon: 'fa-clock',
            text: 'Modifier date de fin',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canUpgrade(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.$router.push({name: 'ResaCreate', params: {id}})
            },
            icon: 'fa-handshake',
            text: 'Passer en réservation',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canUpgrade(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.loadingOptionAction = true
              this.$api.optionService.patch(id, {status: 'approved'}).then(r => {
                this.updateOption(id, r.data, {
                  text: 'L\'option a été acceptée.', type: 'is-success'
                })
              })
            },
            icon: 'fa-check',
            text: 'Accepter',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canApprove(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.loadingOptionAction = true
              this.confirmDelete().then(r => {
                if (r.value) {
                  this.$api.optionService.patch(id, {status: 'refused'}).then(r => {
                    this.updateOption(id, r.data, {text: 'L\'option a été refusée.', type: 'is-success'})
                  })
                }
              })
            },
            icon: 'fa-times-octagon',
            needProfile: ['admin', 'sector_manager'],
            text: 'Refuser',
            display: (o) => {
              return this.canRefuse(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.loadingOptionAction = true
              this.deleteOption(id)
              // this.updateOption(id, {}, {text: 'L\'option a été acceptée.', type: 'is-success'})
            },
            icon: 'fal fa-undo',
            text: 'Annuler option',
            display: (o) => {
              return this.canCancel(o.status)
            }
          }
        ],
        optionButtonListWaitingOption: [
          {
            action: (id, option) => {
              this.$store.commit('setQuickview', {mode: 'OPTION_UPDATE_DATE', params: {source: option}})
            },
            icon: 'fa-clock',
            text: 'Modifier date de fin',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canUpgrade(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.$router.push({name: 'ResaCreate', params: {id}})
            },
            icon: 'fa-handshake',
            text: 'Passer en réservation',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canUpgrade(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.loadingOptionAction = true
              this.$api.optionService.patch(id, {status: 'approved'}).then(r => {
                this.updateOption(id, r.data, {
                  text: 'L\'option a été acceptée.', type: 'is-success'
                })
              })
            },
            icon: 'fa-check',
            text: 'Accepter',
            needProfile: ['admin', 'sector_manager'],
            display: (o) => {
              return this.canApprove(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.loadingOptionAction = true
              this.confirmDelete().then(r => {
                if (r.value) {
                  this.$api.optionService.patch(id, {status: 'refused'}).then(r => {
                    this.updateOption(id, r.data, {text: 'L\'option a été refusée.', type: 'is-success'})
                  })
                }
              })
            },
            icon: 'fa-times-octagon',
            needProfile: ['admin', 'sector_manager'],
            text: 'Refuser',
            display: (o) => {
              return this.canRefuse(o.status)
            }
          },
          {
            action: (id) => {
              if (this.loadingOptionAction) return
              this.loadingOptionAction = true
              this.deleteOption(id)
              // this.updateOption(id, {}, {text: 'L\'option a été acceptée.', type: 'is-success'})
            },
            icon: 'fal fa-undo',
            text: 'Annuler option',
            display: (o) => {
              return this.canCancel(o.status)
            }
          }
        ],
        advButtonList: [
          {
            icon: 'fa-clipboard-list',
            text: 'Accéder à l\'Adv',
            action: (advPk) => {
              this.goToAdvView(advPk)
            }
          },
          {
            icon: 'fa-file-excel',
            text: 'Export xls',
            display: (adv) => {
              return this.isAdmin || this.isSectorManager
            },
            action: (advPk, data) => {
              if (this.loadingOptionAction) return
              this.loadingOptionAction = true
              const apiUrl = this.$configs.APIROOT
              const exportURl = `${apiUrl}/export/adv?pk[]=${advPk}`
              const ref = data.ref
              downloadURI(exportURl, `ADV-N°${ref}-export.xlsx`)
              this.loadingOptionAction = false
            }
          }
        ]
      }
    },
    props: {
      fromOption: Boolean,
      lot: Object,
      externalSale: Object,
      adv: Object,
      userPendingOption: Object,
      firstOption: [Object, Boolean],
      waitingList: Array,
      pendingOptions: Array,
      loading: Boolean
    },
    computed: {
      ...mapGetters(['isAdmin', 'isSectorManager']),
      displayExternalOption () {
        return this.lot.status === 'optioned' && isEmpty(this.rawOptions) &&
          isEmpty(this.myOptions) && isEmpty(this.pendingOptions) &&
          isEmpty(this.firstOption)
      }
    },
    watch: {
      loading (v) {
        this.loadingOptionAction = v
      }
    },
    methods: {
      checkIsEmpty (val) {
        return !isEmpty(val)
      },
      updateOption (id, option, {text, type}) {
        if (!text) {
          text = 'L\'option a été mise à jour.'
        }
        if (!type) {
          type = 'is-success'
        }
        this.$emit('updateOption')
        this.loadingOptionAction = false
        this.$notify({
          type,
          text
        })
      },
      deleteOption (id) {
        this.confirmDelete().then(r => {
          if (r.value) {
            this.$api.optionService.delete(id).then(r => {
              this.$emit('updateOption')
              this.loadingOptionAction = false
              this.$notify({
                type: 'is-success',
                text: 'L\'option a été supprimée.'
              })
            }).catch(r => {
              this.loadingOptionAction = false
              this.$notify({
                type: 'is-danger',
                text: 'Impossible de supprimer l\'option.'
              })
            })
          }
        })
      },
      confirmDelete () {
        return this.$swal({
          title: 'Annulation',
          text: 'Êtes vous sûr de vouloir annuler cette option ?'
        })
      },
      goToAdvView (advPk) {
        this.$router.push({name: 'AdvInfos', params: {id: advPk}})
        // if (this.isAdmin) {
        // } else {
        //   this.$router.push({name: 'AdvRecap', params: {id: advPk}})
        // }
      }
    },
    created () {
      if (this.fromOption) {
        this.displayPendingList = true
      }
    }
  }
</script>

<style scoped>
  .notification a {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/lot/LotStatusNotifications.vue